import styled from '@mui/material/styles/styled';

export const StyledAnchor = styled('a')({
  textDecoration: 'none',
  '&:focus, &:active': {
    outline: 'none',
  },
});
